/**
 * F14.4 — Componente sentinela que sincroniza o locale do I18nProvider
 * com `app_users.locale` retornado pelo `auth.me`.
 *
 * Regras:
 *   - Roda APENAS uma vez por sessão (ref `synced`). Evita sobrescrever
 *     mudanças do user via LanguageSwitcher após sync inicial.
 *   - Se localStorage `edsp.locale` JÁ EXISTE e bate com user.locale → no-op.
 *   - Se diferente → adota `user.locale` (server é source of truth pós-login).
 *   - Pré-login (user=null) → não faz nada; I18nProvider já lê localStorage.
 *
 * Não renderiza UI. Coloca como filho do trpc.Provider e do I18nProvider.
 */

import { useEffect, useRef } from "react";
import { useAuth } from "../hooks/useAuth.js";
import { useI18n } from "./I18nProvider.js";
import { LOCALES, type Locale } from "./messages.js";

export function LocaleSyncFromAuth() {
  const { user } = useAuth();
  const { locale, setLocale } = useI18n();
  const synced = useRef(false);

  useEffect(() => {
    if (synced.current) return;
    if (!user) return;
    const userLocale = (user as { locale?: string }).locale;
    if (!userLocale) return;
    if (!(LOCALES as readonly string[]).includes(userLocale)) return;
    synced.current = true;
    if (userLocale !== locale) {
      setLocale(userLocale as Locale);
    }
  }, [user, locale, setLocale]);

  return null;
}
